<template>
  <div>
    <el-form
      ref="form"
      label-position="top"
      :model="form"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="20">
        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="策略名称" prop="transferRuleName">
            <el-input
              v-model="form.transferRuleName"
              placeholder="请输入中转策略名称"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="策略类型" prop="transferRuleType">
            <el-select
              filterable
              v-model="form.transferRuleType"
              placeholder="请选择中转策略类型"
              clearable
              style="width:100%"
              size="small"
            >
              <el-option label="一键中转策略" value="A"></el-option>
              <el-option label="指定中转策略" value="B"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="组织机构" prop="orgCode">
            <org-cascader
              :valueString.sync="form.orgAllCode"
              :lastValue.sync="form.orgCode"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="客户">
            <dict-select
              filterable
              v-model="form.custCode"
              url="/master/customer/info/select"
              placeholder="请选择客户"
            ></dict-select>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="始发地：省/市/县">
            <region-cascader
              :show="regionShow"
              :provinceCode.sync="form.originProvinceCode"
              :provinceName.sync="form.originProvinceName"
              :cityCode.sync="form.originCityCode"
              :cityName.sync="form.originCityName"
              :districtCode.sync="form.originDistrictCode"
              :districtName.sync="form.originDistrictName"
              :props="{ checkStrictly: true }"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="始发地：详细地址" prop="originPlace">
            <el-input
              v-model="form.originPlace"
              placeholder="请输入始发地详细地址"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="目的地：省/市/县">
            <region-cascader
              :show="regionShow"
              :provinceCode.sync="form.destinationProvinceCode"
              :provinceName.sync="form.destinationProvinceName"
              :cityCode.sync="form.destinationCityCode"
              :cityName.sync="form.destinationCityName"
              :districtCode.sync="form.destinationDistrictCode"
              :districtName.sync="form.destinationDistrictName"
              :props="{ checkStrictly: true }"
            />
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="目的地：详细地址" prop="destination">
            <el-input
              v-model="form.destination"
              placeholder="请输入目的地详细地址"
              clearable
              size="small"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 16 }" :lg="{ span: 12 }">
          <el-form-item label="备注信息" prop="transferRuleRemarks">
            <el-input
              v-model="form.transferRuleRemarks"
              placeholder="请输入备注信息"
              clearable
              size="small"
              type="textarea"
              :rows="5"
            />
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 12 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item label="状态" prop="transferRuleStatus">
            <el-radio-group v-model="form.transferRuleStatus">
              <el-radio label="Y">有效</el-radio>
              <el-radio label="N">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'

export default {
  props: {
    disabled: Boolean,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      regionShow: false,
      saveresult: null,
      form: { transferRuleStatus: 'Y' },
      rules: {
        transferRuleName: [
          { required: true, message: '请输入中转策略名称', trigger: 'blur' },
          { max: 66, message: '中转站名称 字数最多为66位', trigger: 'blur' },
        ],
        transferRuleType: [
          { required: true, message: '请选择中转策略类型', trigger: 'change' },
        ],
        orgCode: [
          { required: true, message: '请选择组织机构', trigger: 'change' },
        ],
        transferRuleStatus: [
          { required: true, message: '请选择有效状态', trigger: 'change' },
        ],
        originPlace: [
          { max: 33, message: '始发地 字数最多为33位', trigger: 'blur' },
        ],
        destination: [
          { max: 33, message: '始发地 字数最多为33位', trigger: 'blur' },
        ],
        originProvinceName: [
          {
            max: 16,
            message: '始发地省份名称 字数最多为16位',
            trigger: 'blur',
          },
        ],
        originCityName: [
          {
            max: 16,
            message: '始发地城市名称 字数最多为16位',
            trigger: 'blur',
          },
        ],
        originDistrictName: [
          {
            max: 16,
            message: '始发地区县名称 字数最多为16位',
            trigger: 'blur',
          },
        ],
        destinationProvinceName: [
          {
            max: 16,
            message: '目的地省份名称 字数最多为16位',
            trigger: 'blur',
          },
        ],
        destinationCityName: [
          {
            max: 16,
            message: '目的地城市名称 字数最多为16位',
            trigger: 'blur',
          },
        ],
        destinationDistrictName: [
          {
            max: 16,
            message: '目的地区县名称 字数最多为16位',
            trigger: 'blur',
          },
        ],
        transferRuleRemarks: [
          { max: 166, message: '备注信息 字数最多为166位', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getResult() {
      return this.saveresult
    },
    getData() {
      if (!this.params.transferRuleCode) return (this.regionShow = true)
      this.$api
        .masterTransferRuleDetailApi({
          transferRuleCode: this.params.transferRuleCode,
        })
        .then((res) => {
          this.form = res.body
          this.regionShow = true
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      let loadingInstance = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$api
        .masterTransferRuleSaveApi(this.form)
        .then((res) => {
          loadingInstance.close()
          this.$emit('codeChange', res.body)
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
  },
}
</script>
